'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var DialogCancelAndConfirm = require('../footers/DialogCancelAndConfirm/DialogCancelAndConfirm.js');
require('../footers/WarningFooter/WarningFooter.js');
require('../footers/SingleRightButtonFooter/SingleRightButtonFooter.js');
require('../footers/SpreadButtonFooter/SpreadButtonFooter.js');
require('../footers/ThreeButtonFooter/ThreeButtonFooter.js');
var DialogActions = _interopDefault(require('@material-ui/core/DialogActions'));
var DialogTitle = _interopDefault(require('@material-ui/core/DialogTitle'));
var DialogContent = _interopDefault(require('@material-ui/core/DialogContent'));
var styledComponents = require('./styled-components.js');

var ConfirmationDialog = function (props) {
    var confirmHandler = props.confirmHandler, cancelHandler = props.cancelHandler, titleText = props.titleText, confirmButtonTitle = props.confirmButtonTitle, textComponent = props.textComponent, open = props.open, _a = props.DialogFooter, DialogFooter = _a === void 0 ? DialogCancelAndConfirm : _a, _b = props.disabledConfirm, disabledConfirm = _b === void 0 ? false : _b;
    var contentStyle = titleText ? {} : { paddingTop: '2rem', width: '322px' };
    return (React__default.createElement(styledComponents.Dialog, { open: open, maxWidth: 'sm' },
        titleText && React__default.createElement(DialogTitle, null, titleText),
        React__default.createElement(DialogContent, { style: contentStyle }, textComponent),
        React__default.createElement(DialogActions, null,
            React__default.createElement(DialogFooter, { confirmTitle: confirmButtonTitle, confirmHandler: confirmHandler, cancelHandler: cancelHandler, disabledConfirm: disabledConfirm }))));
};

module.exports = ConfirmationDialog;
